module.exports = __webpack_public_path__ + "img/6.9.TU.3b3f1f63.png";